import { Box, Tooltip } from '@mui/material';
import TextLink from '../TextLink';
import { SystemCssProperties, Theme } from '@mui/system';

export const longTextContainerSx: SystemCssProperties<Theme> = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export function DataGridTextWithTooltipCell({
  text,
  href,
}: {
  text: string;
  href?: string;
}) {
  return (
    <Tooltip title={text} disableInteractive>
      {href ? (
        <TextLink href={href} sx={longTextContainerSx}>
          {text}
        </TextLink>
      ) : (
        <Box sx={longTextContainerSx}>{text}</Box>
      )}
    </Tooltip>
  );
}
